<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><br/><br/><br/><br/><br/><br/><span class="big1">THE</span><br/><br/><span class="big">ENTITY</span><br/></p>
<p class="center"><img alt="" src="images/9780312375942_001.png"/><br/><br/>FIVE CENTURIES<br/>OF SECRET VATICAN<br/>ESPIONAGE</p>
<p class="center"><br/><br/><br/>ERIC FRATTINI</p>
<p class="center"><em>Translated by Dick Cluster</em></p>
<p class="center"><br/><br/><br/><br/><br/><span class="small">ST. MARTIN’S PRESS</span>   <img alt="" src="images/9780312375942_tit.png"/>   <span class="small">NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_tp_r1.vue?29ee4e0e